import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import ArchiveIcon from '@mui/icons-material/Archive';
import { ReactNode } from "react";

interface ArchiveButtonProps {
    loading: boolean;
    disabled?: boolean;
    onClick: () => void;
    label?: ReactNode
}

export const ArchiveButton: React.FC<ArchiveButtonProps> = ({ loading, disabled = false, onClick, label }) => {
    return (
        <LoadingButton
            loading={loading}
            disabled={disabled}
            size="small"
            color="success"
            variant="contained"
            startIcon={<ArchiveIcon />}
            onClick={onClick}
        >
            {label ? label : <Localized id="archive">_Archiwizuj</Localized>}
        </LoadingButton>
    );
};
